import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, post } from '../models/base';

export const fetchTransactions = createAsyncThunk(
  'transactions/fetchTransactions',
  async (_, { rejectWithValue, getState }) => {
    const { pageNumber, perPage } = getState().transactions;
    try {
      const response = await get(
        `/transactions?page=${pageNumber}&per_page=${perPage}`
      );
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchAdjustedPlanAmount = createAsyncThunk(
  'transactions/fetchAdjustedPlanAmount',
  async (planName, { rejectWithValue, getState }) => {
    try {
      const response = await get(
        `/transactions/adjusted_plan_amount?new_plan_name=${planName}`
      );
      return {
        response,
        planName,
      };
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const addAlbumshotCredits = createAsyncThunk(
  'transactions/addAlbumshotCredits',
  async (planName, { rejectWithValue, getState }) => {
    const { album } = getState().album;
    const { folder } = getState().folders;

    try {
      const response = await post(
        `/transactions/credits?new_plan_name=${planName}`
      );
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
